import { Navigate, useLocation } from "react-router-dom-v5-compat";

import { MODAL_ROUTES } from "routing/routes";

import useShowActivateAssignmentNotificationsModal from "./hooks/useShowActivateAssignmentNotificationsModal";

export default function ActivateAssignmentNotificationsModalRedirect() {
  const location = useLocation();
  const routePath = MODAL_ROUTES.STUDENT_ASSIGNMENT_NOTIFICATIONS.buildPath({});
  const routeState = MODAL_ROUTES.STUDENT_ASSIGNMENT_NOTIFICATIONS.buildState({
    background: location
  });

  const { showModal } = useShowActivateAssignmentNotificationsModal();

  if (showModal) {
    return <Navigate to={routePath} state={routeState} />;
  }

  return null;
}
